import { Anchor } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { StateRedux } from '../store/type-redux';
import Button from './Button';
import { getImage } from '../utils';
import Scroll from './Scroll';

interface Props {
  title: string,
  id: number;
  text: string,
  handleClick: any,
}

const CardProduto = ({
  id, title, text, handleClick,
}: Props) => {
  const dispatch = useDispatch();
  const { favorite: { ids } } = useSelector((state: StateRedux) => state);

  const find = () => ids.find((idF) => idF === id);

  const handleClickFavorite = () => {
    if (find()) {
      const newIds = ids.filter((idFavorite) => idFavorite !== id);

      dispatch({
        type: 'FAVORITE',
        favorite: {
          ids: [...newIds],
        },
      });

      return;
    }

    dispatch({
      type: 'FAVORITE',
      favorite: {
        ids: [...ids, id],
      },
    });
  };

  return (
    <div className="col-xl-3 col-md-3">
      <div className="card notion-collection-card">
        <Anchor
          className="btn no-border-focus"
          onClick={handleClick}
          style={{ padding: 0 }}
        >
          <img src={`/images/${getImage(title)}`} className="card-img-top" height="128" alt="..." />
        </Anchor>
        <div
          style={{ height: 160, borderTop: '1px solid #E0E0E0' }}
        >
          <div
            className="d-flex"
            style={{ justifyContent: 'space-between' }}
          >
            <Anchor
              className="btn no-border-focus d-flex align-items-center"
              onClick={handleClick}
              style={{ padding: 0, width: '100%', paddingInline: 10 }}
            >
              <h6 className="card-title font-weight-bold text-left m-0">
                {title}
              </h6>
            </Anchor>
            <Button
              className="btn no-border-focus"
              onClick={handleClickFavorite}
            >
              <i className={`fas fa-star ${find() ? 'text-warning' : ''}`} />
            </Button>
          </div>
          <Anchor
            className="btn no-border-focus d-flex"
            onClick={handleClick}
            style={{ padding: 0, height: '74%', paddingInline: 10 }}
          >
            <div className="card-text text-left">
              <Scroll height={100}>
                <p>
                  {text}
                </p>
              </Scroll>
            </div>
          </Anchor>
        </div>
      </div>
    </div>
  );
};

export default CardProduto;
